import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

import CaregiverDetails from './caregiver_details/CaregiverDetails';
import CaregiverTitle from './title/CaregiverTitle';
import CaregiverAnnouncement from './announcement/CaregiverAnnouncement';

const CaregiverHeader = (props) => {
  const caregiverRn = props.caregiverRn;
  const caregiverData = props.caregiverData;
  const caregiverBioQuestions = props.caregiverBioQuestions;
  const caregiverBackend = props.caregiverBackend;
  const refresh = props.refresh;
  const setRefresh = props.setRefresh;
  return (
    <Stack gap={1}>
      <CaregiverTitle
        caregiverRn={caregiverRn}
        caregiverData={caregiverData}
        caregiverBackend={caregiverBackend}
      />
      <CaregiverDetails
        caregiverData={caregiverData}
        caregiverBioQuestions={caregiverBioQuestions}
        caregiverBackend={caregiverBackend}
        refresh={refresh}
        setRefresh={setRefresh}
      />
      <CaregiverAnnouncement
        caregiverRn={caregiverRn}
        caregiverData={caregiverData}
        caregiverBackend={caregiverBackend}
      />
    </Stack>
  );
};
CaregiverHeader.propTypes = {
  caregiverRn: PropTypes.string.isRequired,
  caregiverData: PropTypes.object.isRequired,
  caregiverBioQuestions: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
  refresh: PropTypes.number.isRequired,
  setRefresh: PropTypes.func.isRequired,
};

export default React.memo(CaregiverHeader);
